









import { Component, Prop, Vue } from "vue-property-decorator";
import Editor from "@tinymce/tinymce-vue";
import { fixedHtmlData } from "@/services/posts/postTypes/fixedhtml";
import { restoreSelection, saveSelection } from "@/services/posts/postsService";
import { bus } from "@/bus";
import { Font, FontStatusEnum } from "@/services/fonts/types";
import { getAllFonts } from "@/services/fonts/fontsService";

@Component({
    components: {
        Editor
    }
})
export default class FormatTextComponentForm extends Vue {
    @Prop() vsid!: string;

    timeout = 0;
    isOverflowing = false;
    fontString = "";
    loaded = false;
    prevState = "";
    prevCarat = {
        start: 0,
        end: 0
    };

    defaultToolbar = "bold italic";
    defaultFontSizes = "12px 14px 16px 20px 24px 28px 36px 48px 60px 72px 96px 112px";

    init = {};

    created() {
        bus.$on("getComponentData", () => {
            if (this.$refs.text) {
                const text = (this.$refs.text as any).element.innerHTML;
                this.properties.text = text;
            }
        });

        this.loadFonts().then(() => {
            this.init = {
                inline: true,
                menubar: false,
                plugins: "paste lists",
                paste_as_text: true,
                toolbar: this.properties.toolbar || this.defaultToolbar,
                fontsize_formats: this.properties.fontSizes || this.defaultFontSizes,
                forced_root_block: "div",
                font_formats: this.fontString,
                setup: (editor: any) => {
                    editor.on("init", (e: any) => {
                        editor.on("input", this.handleInput);
                        editor.on("keydown", this.saveCaratPosition);
                        editor.on("paste", this.saveCaratPosition);
                        editor.on("click", this.saveCaratPosition);

                        if (this.preventOverflow) {
                            this.prevState = editor.bodyElement.innerHTML;
                        }
                    });
                }
            };
            this.loaded = true;
        });
    }

    destroyed() {
        bus.$off("getComponentData");
    }

    get properties(): fixedHtmlData {
        return ((this.$parent as any).localProperties.data).filter((x: fixedHtmlData) => x.id === this.vsid)[0];
    }

    get preventOverflow() {
        return this.properties.preventOverflow === "true";
    }

    async loadFonts() {
        let localFonts: Font[] = await getAllFonts();
        localFonts = localFonts.filter(f => f.status === FontStatusEnum.Active);

        if (localFonts.length > 0) {
            localFonts.sort((a, b) => a.displayName.localeCompare(b.displayName));

            this.fontString = "";
            for (let index = 0; index < localFonts.length; index++) {
                const element = localFonts[index];
                this.fontString += `${element.displayName}=${element.technicalName};`;
            }
        }
    }

    handleInput() {
        if (!this.preventOverflow) return;
        const textRef = (this.$refs.text as any).element;

        this.isOverflowing = (textRef.scrollHeight > textRef.clientHeight) || (textRef.scrollWidth > textRef.offsetWidth);
        if (this.isOverflowing) {
            // If we're overflowing, restore the state to previous state and also restore the carat position.
            textRef.innerHTML = this.prevState;
            restoreSelection(textRef, this.prevCarat);

            // Turning the overflow off after 150ms means we get a quick red-flash on the border to indicate the action the user did caused overflow.
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.isOverflowing = false;
            }, 150);
            return;
        }
        this.prevState = textRef.innerHTML;
    }

    saveCaratPosition(e: any) {
        if (this.preventOverflow) {
            setTimeout(() => {
                this.prevCarat = saveSelection(e.currentTarget);
            }, 0);
            this.handleInput();
        }
    }
}
